import React from "react";
import styled from "styled-components";
import NamedItemManager from "../components/NamedItemManager";
import { GET_CURRENCIES, ADD_CURRENCY, UPDATE_CURRENCY, DELETE_CURRENCY } from "../api/currency";
import { GET_CATEGORIES, ADD_CATEGORY, UPDATE_CATEGORY, DELETE_CATEGORY } from "../api/category";

const SettingsWrapper = styled.div`
  max-width: 640px;
  margin: 0 auto;
  padding: 1.5em 1em 6em;
  display: flex;
  flex-direction: column;
  gap: 1.5em;
`;

export default function Settings() {
  return (
    <SettingsWrapper>
      <NamedItemManager
        title="幣別設定"
        placeholder="新增幣別（例如：TWD、JPY、USD）"
        dataKey="currencies"
        getQuery={GET_CURRENCIES}
        addMutation={ADD_CURRENCY}
        updateMutation={UPDATE_CURRENCY}
        deleteMutation={DELETE_CURRENCY}
      />
      <NamedItemManager
        title="分類設定"
        placeholder="新增分類（例如：飲食、交通、娛樂）"
        dataKey="categories"
        getQuery={GET_CATEGORIES}
        addMutation={ADD_CATEGORY}
        updateMutation={UPDATE_CATEGORY}
        deleteMutation={DELETE_CATEGORY}
        extraField={{
          key: "type",
          defaultValue: "expense",
          options: [
            { value: "expense", label: "支出", color: "volcano" },
            { value: "income", label: "收入", color: "green" },
          ],
        }}
      />
    </SettingsWrapper>
  );
}
